/* Journey planner */
$(function () {
    $('#showMoreOptions').on('click', function (e) {
        e.preventDefault();

        const $trigger = $(this);
        const $lowerFields = $('.field-group-lower');
        const $bottomFields = $('.field-group-bottom');

        $trigger.toggleClass('__active');
        $lowerFields.toggleClass('__active');
        $bottomFields.toggleClass('__active');
    });

    const $plannerToggle = $('#toggle-journey-planner');
    const $plannerPanel = $('#journey-planner');

    if ($plannerToggle.length && $plannerPanel.length) {
        const togglePlanner = function () {
            const isOpen = $plannerToggle.attr('aria-expanded') === 'true';

            $plannerToggle.attr('aria-expanded', String(!isOpen));
            $plannerPanel.stop(true, true).slideToggle(250);
        };

        $plannerPanel.hide();

        $plannerToggle.on('click', function (e) {
            e.preventDefault();
            togglePlanner();
        });

        $plannerToggle.on('keydown', function (e) {
            if (e.key !== 'Enter' && e.key !== ' ') {
                return;
            }

            e.preventDefault();
            togglePlanner();
        });
    }
});
